export default "__VITE_ASSET__CZ$0L0M8__";